import React from "react";
import { Container } from "./style";

const SectionTitle = ({ children, explain, ...props }) => {
    return <Container {...props}>{children}</Container>;
};

export default SectionTitle;
